import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import favicon from "../images/chainpad/logo.png";
import Header from './Header';
import Sidebar from './Sidebar';

class Chainpadtokenpage extends Component {

    render() {

        return (

            <>
 <div id="loader_main">
        {/* <div id="loader_div">
          <span className="spin_round">
          </span>
          <img src={favicon} className="logo_load" />
        </div> */}
        {/* <div className='logo_overlay' id="logo_overlay"> */}
        <Header />

        <div className="whole_sec pb-5">
            <div className='flex_side_right'>
            <Sidebar />
            <div className='right_side_sec'>




          </div>

            </div>
          </div>

        </div>
      {/* </div> */}
            </>
        )
    }

}

export default Chainpadtokenpage;